import { Component, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '@src/app/services/common.service';
import { TelegramService } from '@src/app/services/telegram.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { getChainImg } from '@src/app/shared/types/wallet-chain.type';
import { formatNumberWithPrefix, formatTinyNumber } from '@src/app/shared/utils/number.util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { finalize } from 'rxjs';
import { MemeDashboardStatusService } from '../../meme-dashboard-status.service';
import { MemeDashboardService } from '../../meme-dashboard.service';
import { WatchlistAgentInfo } from '../../meme-dashboard.type';

@Component({
    selector: 'app-watchlist-agent-card',
    templateUrl: './watchlist-agent-card.component.html',
    styleUrls: ['./watchlist-agent-card.component.less'],
})
export class WatchlistAgentCardComponent {
    @Input() agentInfo: WatchlistAgentInfo;
    formatNumberWithPrefix = formatNumberWithPrefix;
    formatTinyNumber = formatTinyNumber;
    getChainImg = getChainImg;

    hovering = false;

    submitting = false;

    shareModalVisible = false;

    unsubscribeModalVisible = false;

    @HostListener('mouseenter', ['$event'])
    @HostListener('mouseleave', ['$event'])
    onHover(event: MouseEvent) {
        this.hovering = event.type === 'mouseenter';
    }

    get isMyWatchlist() {
        return this.agentInfo.id === this.walletStatusService.userProfile?.watchlist?.id;
    }

    get isWatchListAdded() {
        return this.walletStatusService.userProfile?.watchlist?.address_added;
    }

    get isAuthenticated() {
        return this.walletStatusService.isWalletConnected || this.tgService.isTGLogin;
    }

    constructor(
        public memeDashboardService: MemeDashboardService,
        public memeDashboardStatusService: MemeDashboardStatusService,
        public commonService: CommonService,
        private walletStatusService: WalletStatusService,
        private tgService: TelegramService,
        private router: Router
    ) {}

    subscribe() {
        if (!this.isAuthenticated) {
            this.commonService.showLogInModal();
            return;
        }

        this.submitting = true;
        this.memeDashboardService
            .subscribeWatchlist(this.agentInfo.id)
            .pipe(finalize(() => (this.submitting = false)))
            .subscribe({
                next: () => {
                    this.agentInfo.is_subscribed = true;

                    this.memeDashboardStatusService.fetchMySubscribedWatchlistAgents();

                    if (!this.memeDashboardStatusService.memeAgentInitialized) {
                        this.memeDashboardStatusService.showTGAgentSetupGuide('init_tg_agent');
                    }
                },
                error: err => {
                    console.log(err);
                    if (err.body.code === 400) {
                        if (err.body.message.includes('You can only subscribe up to')) {
                            this.commonService.errorMessageByResponse(err);
                        } else {
                            this.memeDashboardStatusService.showInsufficientPointsModal(this.agentInfo);
                        }
                    } else {
                        this.commonService.errorMessageByResponse(err);
                    }
                },
            });
    }

    unsubscribe() {
        this.submitting = true;
        this.memeDashboardService
            .unsubscribeWatchlist(this.agentInfo.id)
            .pipe(finalize(() => (this.submitting = false)))
            .subscribe({
                next: () => {
                    this.agentInfo.is_subscribed = false;

                    this.memeDashboardStatusService.mySubscribedWatchlistAgentIDs$.next(
                        this.memeDashboardStatusService.mySubscribedWatchlistAgentIDs$.getValue().filter(id => id !== this.agentInfo.id)
                    );

                    this.unsubscribeModalVisible = false;

                    this.commonService.success('Unsubscribed Successfully');
                },
                error: err => this.commonService.errorMessageByResponse(err),
            });
    }

    goWatchlist() {
        if (this.isAuthenticated) {
            if (this.agentInfo.id === this.walletStatusService.userProfile?.watchlist?.id) {
                this.router.navigate(['/meme-dashboard/my-watchlist']);
            } else {
                this.router.navigate(['/meme-dashboard/watchlist-marketplace', this.agentInfo.id]);
            }
        } else {
            this.commonService.showLogInModal();
        }
    }
}
